// import Global from "../global";
import { enums } from '@888sport/uc-sportclient-lib/dist/uc-sportclient-lib.min';
import {
  /*getPathName, */ logRequestToClickstream,
  responseErrorCb,
  responseSuccessCb
} from '../utils/logging';

const { eHTTPMethods } = enums;

export class Http {
  constructor(axiosInstance) {
    this.axiosInstance = axiosInstance;
  }

  get(logData, url, params = {}, logToClickStream = false, headers = null) {
    const requestData = { url, params, method: eHTTPMethods.GET };

    // duplicate with the interceptors log
    // Global.logger.debug(`[REQ ${getPathName(url)}] Request data: ${JSON.stringify(requestData)}`);

    if (logToClickStream) logRequestToClickstream(requestData, logData);

    return this.axiosInstance.get(url, { params, headers }).then(
      response => {
        responseSuccessCb(response, requestData, logData, logToClickStream);
        return response;
      },
      error => {
        responseErrorCb(error, requestData, logData, logToClickStream);
      }
    );
  }

  post(
    logData,
    url,
    data = {},
    params = {},
    logToClickStream = false,
    headers = null
  ) {
    const requestData = { url, params, data, method: eHTTPMethods.POST };
    const options = headers ? { params, headers } : { params };

    // duplicate with the interceptors log
    // Global.logger.debug(`[REQ ${getPathName(url)}] Request data: ${JSON.stringify(requestData)}`);

    if (logToClickStream) logRequestToClickstream(requestData, logData);

    return this.axiosInstance.post(url, data, options).then(
      response => {
        responseSuccessCb(response, requestData, logData, logToClickStream);
        return response;
      },
      error => {
        responseErrorCb(error, requestData, logData, logToClickStream);
      }
    );
  }

  delete(logData, url, params = {}, logToClickStream = false, headers = null) {
    const requestData = { url, params, method: eHTTPMethods.DELETE };

    // duplicate with the interceptors log
    // Global.logger.debug(`[REQ ${getPathName(url)}] Request data: ${JSON.stringify(requestData)}`);

    if (logToClickStream) logRequestToClickstream(requestData, logData);

    return this.axiosInstance.delete(url, { params, headers }).then(
      response => {
        responseSuccessCb(response, requestData, logData, logToClickStream);
        return response;
      },
      error => {
        responseErrorCb(error, requestData, logData, logToClickStream);
      }
    );
  }
}
